var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTotalAvailableRollback = function SvgTotalAvailableRollback(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17645_80482)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6465 4.46L5.74703 4.46C5.19474 4.46 4.74703 4.90772 4.74703 5.46L4.74703 8.46C4.74703 9.01229 5.19474 9.46 5.74703 9.46L18.6465 9.46C19.0443 9.46 19.4259 9.61804 19.7072 9.89934L60.0019 50.194L63.5374 46.6585L23.2427 6.36381C22.0237 5.14482 20.3704 4.46 18.6465 4.46Z",
    fill: "#FFD977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4161 48.7808L21.1214 8.48614C20.465 7.82977 19.5748 7.46102 18.6465 7.46102L4.74846 7.46102L4.74711 7.6682L4.74703 8.46102C4.74703 9.0133 5.19474 9.46102 5.74703 9.46102H18.6465C19.0443 9.46101 19.4259 9.61905 19.7072 9.90036L60.0019 50.195L61.4161 48.7808Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9098 11.2033C30.1288 10.4222 28.8624 10.4222 28.0814 11.2033L24.4245 14.8601C24.0495 15.2352 23.8388 15.7439 23.8388 16.2743L23.8388 28.7596C23.8388 29.2901 24.0495 29.7988 24.4245 30.1738L33.7382 39.4875C35.3003 41.0496 37.833 41.0496 39.3951 39.4875L47.8804 31.0023C48.6614 30.2212 48.6614 28.9549 47.8804 28.1738L30.9098 11.2033Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4958 12.6173C28.7147 11.8363 27.4484 11.8363 26.6673 12.6173L23.6126 15.6721C22.8528 16.4319 22.4306 17.4654 22.4412 18.5399L22.5211 26.6524C22.5314 27.6996 22.952 28.701 23.6925 29.4415L33.7384 39.4874C35.3005 41.0495 37.8332 41.0495 39.3953 39.4874L46.4663 32.4163C47.2474 31.6353 47.2474 30.3689 46.4663 29.5879L29.4958 12.6173Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4455 24.6369C33.6644 23.8558 32.3981 23.8558 31.617 24.6369L28.0815 28.1724C27.3005 28.9535 27.3005 30.2198 28.0815 31.0008L35.1526 38.0719C35.9336 38.8529 37.1999 38.8529 37.981 38.0719L42.2236 33.8293C42.6142 33.4387 42.6142 32.8056 42.2236 32.415L34.4455 24.6369Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4455 24.6369C33.6644 23.8558 32.3981 23.8558 31.617 24.6369L28.0815 28.1724L36.5668 36.6577C37.3478 37.4387 38.6142 37.4387 39.3952 36.6577L42.9307 33.1222L34.4455 24.6369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3241 9.78921C31.5431 9.00816 30.2767 9.00817 29.4957 9.78921L28.0815 11.2034C27.3004 11.9845 27.3004 13.2508 28.0815 14.0319L35.1526 21.1029C35.9336 21.884 37.1999 21.884 37.981 21.1029L39.3952 19.6887C40.1762 18.9077 40.1762 17.6413 39.3952 16.8603L32.3241 9.78921Z",
    fill: "#FFC01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6326 36.4824L33.617 29.4668C33.2419 29.0917 32.7332 28.881 32.2027 28.881H26.6672",
    stroke: "#CC963E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.759 33.123L44.3448 34.5373L60.0017 50.1941L61.4159 48.7799L45.759 33.123Z",
    fill: "#CC963E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8804 31.002L45.7591 33.1233L61.4159 48.7801L63.5372 46.6588L47.8804 31.002Z",
    fill: "#FFC01E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17645_80482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTotalAvailableRollback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "total-available-rollback.81e294d30a02cf4961992c86fe8bf9fd.svg";